<app-header></app-header>
<app-progress-bar [planeColor]="'#0045b6'" [passengerColor]="'#0045b6'" [seatColor]="'#0045b6'"></app-progress-bar>
<app-seat-picker></app-seat-picker>
<app-footer></app-footer>